/**
 * The default time interval in secondswhen using using event mode
 *
 *
 * @beta
 */
export const CMCD_DEFAULT_TIME_INTERVAL = 30
